import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useColor } from '@hub/hooks';
import {
  Card,
  Col,
  Flex,
  ProgressSlider,
  Row,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { IconsNames, ThemeColors } from '@monorepo/types';
import { ProfitableDaysProps } from '../../progress-cards-5ers/profitable-days-progress';
import { AccountRulesCardIcon } from '../account-rules-icon/account-rules-icon';

import '../account-rules.scss';

const ProfitableDaysRuleTTPCard: FunctionComponent<
  Omit<ProfitableDaysProps, 'tooltipText'>
> = ({ currentProfitableDays, profitableDaysTarget, openModal, isLoading }) => {
  const { getColor } = useColor();
  const { isMobile } = useResponsiveness();
  const { t } = useTranslation(['dashboardTemplates']);

  const completeInPercentage =
    (currentProfitableDays / profitableDaysTarget) * 100;

  return (
    <Card hoverable={false} className={'account-rules'} onClick={openModal}>
      <Row
        gutter={[5, 10]}
        className={classNames({
          'account-rules__row--mobile': isMobile,
        })}
      >
        <Col
          span={8}
          sm={24}
          className={classNames({
            'account-rules__col--mobile': isMobile,
          })}
        >
          <Flex
            justify={'space-between'}
            gap={5}
            className={classNames('account-rules__header', {
              'account-rules__mobile': isMobile,
            })}
          >
            <Col span={18}>
              <Flex gap={5} align={'center'} wrap="wrap">
                <TextComponent
                  responsive={false}
                  color={getColor(ThemeColors.colorPrimary)}
                  weight={600}
                >
                  {t('dashboardTemplates:profitable_days')}
                </TextComponent>
              </Flex>
            </Col>
            <Row>
              <AccountRulesCardIcon iconName={IconsNames.Trophy} />
            </Row>
          </Flex>
        </Col>

        <Col span={16} sm={24}>
          <Flex
            justify={'end'}
            vertical
            className={'account-rules__slider-section'}
          >
            <Flex justify="space-between" align="end">
              <Flex align="center">
                <TextComponent
                  loading={isLoading}
                  weight={600}
                  level={3}
                  responsive={false}
                >
                  {currentProfitableDays}/
                </TextComponent>
                <TextComponent level={3} responsive={false}>
                  {profitableDaysTarget}
                </TextComponent>
              </Flex>
              <TextComponent loading={isLoading} level={4} responsive={false}>
                {completeInPercentage?.toFixed(0)}%
              </TextComponent>
            </Flex>

            <ProgressSlider
              disabled
              value={currentProfitableDays}
              trackColor={ThemeColors.colorSuccess}
              max={profitableDaysTarget}
            />
          </Flex>
        </Col>
      </Row>
    </Card>
  );
};

export default ProfitableDaysRuleTTPCard;
